import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { tableRowSx } from "services/constants";
import { advanceSalaryHeader } from "../Headers";

const keys = [
  "status",
  "user_name",
  "repayment_date",
  "next_repayment_date",
  "amount",
  "advance_type",
  "description",
  "reason",
];

export const History = ({ setLeaveChange, leaveChange }) => {
  const { domain, globalSearchValue, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const {
    result: advanceSalaryDetails,
    setLoad: reCallApi,
    loading,
  } = useFetch(`${domain}advances/?selected_user_id=${userDetails?.id}`);
  const [advanceSalaryData, setAdvanceSalaryData] =
    useState(advanceSalaryDetails);
  const containerRef = useRef(null);

  useEffect(() => {
    if (leaveChange) {
      reCallApi(true);
      setLeaveChange(false);
    }
  }, [leaveChange, reCallApi, setLeaveChange]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const filteredResults = advanceSalaryDetails?.filter((item) =>
      keys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setAdvanceSalaryData(filteredResults);
    setPage(0);
  }, [globalSearchValue, advanceSalaryDetails]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                {advanceSalaryHeader?.map((value) => (
                  <Mui.TableCell
                    sx={{ color: themes.headLine, fontWeight: "bold" }}
                  >
                    {value?.name}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {advanceSalaryData?.length === 0 ? (
                <InfoMessage dataLength={advanceSalaryDetails} />
              ) : (
                advanceSalaryData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((value) => (
                    <Mui.TableRow sx={tableRowSx}>
                      {advanceSalaryHeader.map((head) => (
                        <Mui.TableCell>
                          {value[head.key] ? value[head.key] : "N/A"}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>

      {advanceSalaryData?.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={advanceSalaryData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};
